<template>
  <div class="tw-pb-[105px]">
    <NotificationsFilters @reset="handleReset" />

    <el-tabs
      :model-value="tab"
      class="tw-mt-4 tw-mb-6 tw-border-b tw-border-gray"
      @tab-click="handleTabChange"
    >
      <el-tab-pane
        :label="$t('notifications.title_new')"
        name="new"
      />

      <el-tab-pane name="flagged">
        <template #label>
          <el-badge
            :value="unseenNotificationsCount.count_flagged"
            class="notifications__flagged"
            :hidden="unseenNotificationsCount.count_flagged === 0"
            :max="9"
          >
            {{ $t('notifications.title_flagged') }}
          </el-badge>
        </template>
      </el-tab-pane>
      <el-tab-pane
        :label="$t('notifications.title_all')"
        name="all"
      />
    </el-tabs>
    <div
      v-if="isLoading"
      v-loading="true"
      class="tw-h-52"
    />
    <div v-else>
      <NotificationsNotificationV2
        v-for="notification in notifications"
        :key="notification.id"
        :notification="notification"
        class="tw-mb-2"
        @updateFlag="handleFlagUpdate"
      />
    </div>
    <AdministrationTablePagination
      v-if="!shouldHidePagination"
      store-path="v2/shared/notifications"
      filter-relative-path="filters"
      class="tw-mt-10"
    />
    <ForeignersMessagingPopover />
  </div>
</template>

<script>
import NotificationsFilters from '@/components/Notifications/NotificationsFilters.vue';
import NotificationsNotificationV2 from '@/components/Notifications/NotificationsNotification.vue';
import AdministrationTablePagination from '@/components/Administration/components/AdministrationTablePagination.vue';
import { mapGetters, mapState } from 'vuex';
import { getLocalStorageData, localStorageKeys, updateLocalStorageData } from '@/helpers/localStorageHelpers';
import ForeignersMessagingPopover from '@/components/Foreigners/Messaging/ForeignersMessagingPopover.vue';

export default {
  components: {
    ForeignersMessagingPopover,
    AdministrationTablePagination,
    NotificationsFilters,
    NotificationsNotificationV2,
  },

  data() {
    return {
      tab: '',
      isLoading: false,
    };
  },

  computed: {
    ...mapState({
      notifications: (state) => state.v2.shared.notifications.notifications,
      filters: (state) => state.v2.shared.notifications.filters,
      flags: (state) => state.v2.shared.notifications.flags,
      unseenNotificationsCount: (state) => state.v2.shared.notifications.unseenCount,
    }),
    ...mapGetters({
      shouldHidePagination: 'v2/shared/notifications/shouldHidePagination',
    }),
  },

  watch: {
    filters: {
      handler() {
        this.load();
        const isFirstLoad = this.tab.length === 0;
        if (!isFirstLoad) {
          updateLocalStorageData(localStorageKeys.notifications, { ...this.filters, tab: this.tab, page: 1 });
        }
      },
      deep: true,
      immediate: true,
    },
  },

  async mounted() {
    this.$store.dispatch('v2/shared/notifications/loadFlags');
    const defaultData = getLocalStorageData(localStorageKeys.notifications, {});
    this.tab = defaultData.tab ?? 'new';
    this.isLoading = true;
    await this.load();
    this.isLoading = false;
  },

  methods: {
    async load() {
      await this.$store.dispatch('v2/shared/notifications/load');
    },
    handleTabChange(tab) {
      const name = tab.props.name;
      if (name === 'new') {
        this.$store.commit('v2/shared/notifications/updateFilter', { field: 'is_seen', payload: 2 });
        this.$store.commit('v2/shared/notifications/updateFilter', { field: 'flags', payload: [] });
        updateLocalStorageData(localStorageKeys.notifications, { ...this.filters, tab: 'new' });
      }
      if (name === 'flagged') {
        this.$store.commit('v2/shared/notifications/updateFilter', { field: 'flags', payload: this.flags.map((flag) => flag.id) });
        this.$store.commit('v2/shared/notifications/updateFilter', { field: 'is_seen', payload: 0 });
        updateLocalStorageData(localStorageKeys.notifications, { ...this.filters, tab: 'flagged', page: 1 });
      }
      if (name === 'all') {
        this.$store.commit('v2/shared/notifications/updateFilter', { field: 'is_seen', payload: 0 });
        this.$store.commit('v2/shared/notifications/updateFilter', { field: 'flags', payload: [] });
        updateLocalStorageData(localStorageKeys.notifications, { ...this.filters, tab: 'all', page: 1 });
      }
      this.tab = name;
    },
    handleReset() {
      const isFlaggedTab = this.tab === 'flagged';
      this.$store.commit('v2/shared/notifications/resetFilters', { needToResetIsSeen: isFlaggedTab });
      if (isFlaggedTab) {
        this.tab = 'new';
      }
    },
    handleFlagUpdate() {
      if (this.tab === 'flagged') {
        this.load();
      }
    },
  },
};
</script>
